import { render, staticRenderFns } from "./MReasonsReportWidget.vue?vue&type=template&id=4e7f8002&lang=pug&"
import script from "./MReasonsReportWidget.vue?vue&type=script&lang=js&"
export * from "./MReasonsReportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports